import { render } from "./dropdown_normal.vue?vue&type=template&id=0315bfea&scoped=true"
import script from "./dropdown_normal.vue?vue&type=script&lang=js"
export * from "./dropdown_normal.vue?vue&type=script&lang=js"

import "./dropdown_normal.vue?vue&type=style&index=0&id=0315bfea&lang=less&scoped=true"

import exportComponent from "/Users/aa/work/credit_chakra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0315bfea"]])

export default __exports__